<template>
	<div
		class="stripes"
		:class="{'stripes--animation-stopped': loadingState.type === 'loaded'}"
	>
		<img class="logo" src="@/assets/logo.svg" alt="">
		<div class="stripe stripe-red"></div>
		<div class="stripe stripe-orange"></div>
		<div class="stripe stripe-yellow"></div>
		<div class="stripe stripe-green"></div>
		<div class="stripe stripe-blue"></div>
	</div>
</template>

<script>
import useCustomizer from '@/composables/Customizer';

export default {
	name: 'Loader',
	setup() {
		const { loadingState } = useCustomizer();

		return {
			loadingState,
		};
	},
};
</script>

<style lang="sass" scoped>

.stripes
	display: flex
	width: 100%
	height: 100%
	background-color: #ffffff

.stripe
	height: 100%
	width: 20%

	animation: stripe-animation 2s infinite

.stripe-red
	background-color: #E6353D
	animation-delay: 0s

.stripe-orange
	background-color: #FA9137
	animation-delay: 0.2s

.stripe-yellow
	background-color: #F4A82D
	animation-delay: 0.4s

.stripe-green
	background-color: #7EC04E
	animation-delay: 0.6s

.stripe-blue
	background-color: #2D89CF
	animation-delay: 0.8s

.logo
	position: absolute
	top: 50%
	left: 50%
	transform: translate(-50%, -50%)
	z-index: 1

	width: 30vw

.stripes--animation-stopped
	.stripe
		animation-play-state: paused

@keyframes stripe-animation
	0%
		transform: translateY(0)

	25.9%
		transform: translateY(100%)
	26%
		transform: translateY(-100%)

	50%
		transform: translateY(0)

</style>
